var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckFilledShadow = function SvgCheckFilledShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.741699,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#28A745",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.2417C17.6125 12.2417 12 17.8542 12 24.7417C12 31.6292 17.6125 37.2417 24.5 37.2417C31.3875 37.2417 37 31.6292 37 24.7417C37 17.8542 31.3875 12.2417 24.5 12.2417ZM30.475 21.8667L23.3875 28.9542C23.2125 29.1292 22.975 29.2292 22.725 29.2292C22.475 29.2292 22.2375 29.1292 22.0625 28.9542L18.525 25.4167C18.1625 25.0542 18.1625 24.4542 18.525 24.0917C18.8875 23.7292 19.4875 23.7292 19.85 24.0917L22.725 26.9667L29.15 20.5417C29.5125 20.1792 30.1125 20.1792 30.475 20.5417C30.8375 20.9042 30.8375 21.4917 30.475 21.8667Z",
    fill: "#28A745"
  })));
};
export default SvgCheckFilledShadow;